import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import RoutesSetup from "./routes/RoutesSetup";
import { BrowserRouter } from "react-router-dom";

import { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Modal from "react-modal";
import { useEffect } from "react";

Modal.setAppElement("#root");
function App() {

  useEffect(() => {
    const savedBrandId = localStorage.getItem('selected-brand');
    if (savedBrandId) {
      document.documentElement.setAttribute('data-theme', savedBrandId);
    }
  }, [])

  return (
    <SkeletonTheme baseColor="#f5f5f5" highlightColor="#FFFFFF">
      <BrowserRouter>
        <ScrollToTop>
          <RoutesSetup />
        </ScrollToTop>
      </BrowserRouter>
    </SkeletonTheme>
  );
}

export default App;
